import { useQuery } from "react-query";

import { DirectionsService } from "~/entity/Directions/api/service";
import { IParamsDirections } from "~/entity/Directions/model/shema";

type UseGetDirectionsV2Params = IParamsDirections;

export const useGetDirectionsV2 = (params: UseGetDirectionsV2Params) => {
  return useQuery({
    queryKey: ["directions"],
    queryFn: async () => {
      const res = await DirectionsService.GET.getDirections(params);
      return res.data;
    },
  });
};
